define( 'toolkit/b-tabsheet/b-tabsheet', ['toolkit/b-toolkit/b-toolkit'], function(toolkit) {
	'use strict';

	/**
	 *
	 */

	/**
	 * @fires
	 */

	//эвенты
	// changeTab - меняется активная вкладка
	return toolkit.create( 'b-tabsheet', {
		deferredInit: true,

		init: function () {
			var data = this.getData();

			this._active = data.active || 0;

			this._initElements();
		},

		onRender: function () {
			this._initElements();
		},

		_initElements: function() {
			this.$('.b-tabsheet__tab').on('click', this._onTabClick.bind(this));
		},

		_onTabClick: function (event) {
			//TODO если логика будет усложнена,
			// лушче создать js объекты-блоки на элементы tab и sheet
			// и работать с объектами а не с атрибутами и DOM напрямую
			var index = parseInt($(event.target).attr('data-index'));

			if (isNaN(index)) {
				throw new Error('b-tabsheet error: Некорректный индекс вкладки');
			}

			this._changeTab(index);
		},

		/**
		 * поменять активную вкладку
		 *
		 * !ВАЖНО! не должен эмититься евент changeTab
		 *
		 * @param index
		 */
		activateTab: function (index) {
			this._changeTab(index, true);
		},

		/**
		 * Меняем активную вкладку
		 *
		 * @param {number} index
		 * @param silent если true тогда не генерится события
		 * @private
		 */
		_changeTab: function (index, silent) {
			if (!this.data.items[index]) {
				throw new Error('b-tabsheet error: Вкладки с идентификатором ' + index + ' не существует');;
			}

			this.$('.b-tabsheet__tab').toggleMod('active', false);
			this.$('.b-tabsheet__tab[data-index=' + index + ']').toggleMod('active', true);
			this.$('.b-tabsheet__sheet').toggleMod('active', false);
			this.$('.b-tabsheet__sheet[data-index=' + index + ']').toggleMod('active', true);

			this._active = index;

			if (!silent) {
				this.emit('changeTab', index);
			}
		},

		/**
		 * Возвращает идентификатор активной вкладки
		 *
		 */
		getActiveTab: function () {
			return this._active;
		}
	});
});
